{
  "changedSuccessfully": "Password changed successfully!",
  "setPasswordText": "Enter your new password",
  "passwordChangeFailedText": "The password could not be changed",
  "errorCauses": {
    "wrongCode": "invalid confirmation code",
    "expiredCode": "confirmation code expired",
    "wrongPassword": "password does not meet the requirements",
    "tooManyAttempts": "too many attempts",
    "userNotConfirmed": "the user's email address has not been verified",
    "userNotFound": "user not found"
  },
  "resetCodeSent": "You will receive an email with the confirmation code you need to change your password",
  "resetCodeSent2": "Check your spam folder if you have not received the email",
  "resetCodeInputLabel": "Confirmation code",
  "resetCodeSubmitButtonText": "Change your password",
  "forgotPasswordViewInputEmailDescription": "Enter the email address you use on the residents' pages.",
  "passwordForgottenHeader": "Forgot password",
  "sendForgotPasswordEmailButtonText": "Send request",
  "resetUser": {
    "text": "If you do not remember the account you registered with, you can register again",
    "resetLinkText": "here"
  }
}
